import type { MessageInstanceClickedParams } from '@atlassian/post-office-context/message-instance-event-client';

import {
	mapInteractionToClickedEvent,
	type SemanticInteraction,
} from './interactions/map-to-clicked-event';
import type { PostOfficeUserInteractionHandlers } from './types';

/**
 * Binds semantic handlers to a Post Office-owned transport, for headless integrations whose
 * event context lives outside the message provider. Ordinary message renderers should use
 * usePostOfficeUserInteractions instead. The transport must supply the real message context.
 */
export const createPostOfficeUserInteractionHandlers = (
	send: (event: MessageInstanceClickedParams) => Promise<void>,
): PostOfficeUserInteractionHandlers => {
	const record = (interaction: SemanticInteraction): void => {
		// A failed analytic must not interrupt the user's action.
		void send(mapInteractionToClickedEvent(interaction)).catch(() => {});
	};

	return {
		onCtaActioned: (input) => record({ ...input, kind: 'ctaActioned' }),
		onAcknowledged: (input) => record({ ...input, kind: 'acknowledged' }),
		onDeclined: (input) => record({ ...input, kind: 'declined' }),
		onSnoozed: (input) => record({ ...input, kind: 'snoozed' }),
		onClosed: (input) => record({ ...input, kind: 'closed' }),
		onStepChanged: (input) => record({ ...input, kind: 'stepChanged' }),
	};
};
